import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LanguageSelector } from '../language-selector/language-selector';
import { BrandingService } from '@app/core/branding/branding.service';

@Component({
  selector: 'app-header',
  imports: [LanguageSelector, RouterLink],
  templateUrl: './header.html',
  styleUrl: './header.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Header {
  protected readonly branding = inject(BrandingService).branding;
}
